'use client';

import clsx from 'clsx';
import { ChevronDown } from 'lucide-react';

type Option = {
    value: string;
    label: string;
};

type FormSelectProps = {
    id: string;
    name: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    options: Option[];
    className?: string;
    wrapperClassName?: string;
    autoFocus?: boolean;
    disabled?: boolean;
    showIcon?: boolean;
};

export default function FormSelect({
    id,
    name,
    value,
    onChange,
    options,
    className,
    wrapperClassName,
    autoFocus = false,
    disabled = false,
    showIcon = true,
}: FormSelectProps) {
    const baseClass = `
    w-full
    font-notojp font-medium text-base
    bg-color-inputform-g-bg
    text-color-base
    border border-color-white-base
    focus:outline-none focus:ring-0 focus:border-color-form-border focus:bg-color-white-base
    cursor-pointer rounded-none
    px-4 py-4 block
    appearance-none
  `;

    return (
        <div className={clsx('flex relative', wrapperClassName ?? 'w-full')}>
            <select
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                autoFocus={autoFocus}
                disabled={disabled}
                className={clsx(baseClass, className)}
            >
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>

            {showIcon && (
                <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
                    <ChevronDown className="w-5 h-5 text-color-form-text" />
                </div>
            )}
        </div>
    );
}
